<template>
  <van-popup v-model="show" round closeable close-icon="close">
    <div class="title">检测到可转换的商品</div>
    <van-card
      price="--"
      desc="--"
      title="--"
      thumb="https://img01.yzcdn.cn/vant/ipad.jpeg"
    />
    <div class="footer">
      <van-button type="warning" @click="goDetail()" round size="small"
        >查看商品</van-button
      >
      <van-button type="danger" @click="goShare()" round size="small"
        >赚 -- 元</van-button
      >
    </div>
  </van-popup>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      platform: "", // 当前转链平台
    };
  },
  created() {
    this.platformList = {
      taobao: "/taobao/extractClick",
      pdd: "/pdd/goodsZsUnitUrlGen",
      suning: "/suning/extensionlink",
    };
  },
  mounted() {
    try {
      navigator.clipboard.readText().then((clipText) => this.discern(clipText));
    } catch (e) {}
  },
  methods: {
    //   识别口令和链接
    discern(clipText) {
      console.log(clipText);
      const password = this.getTaoClick(clipText); //淘口令
      let urlObj = this.getUrl(clipText); // 商品url
      console.log("password", password);
      console.log("url", urlObj);
      if (urlObj && urlObj["input"]) {
        const url = urlObj["input"];
        console.log(url);
        this.showPopup(url);
      }
    },
    showPopup(url) {
      if (url.indexOf("pinduoduo.com") > -1) {
        this.platform = "pdd";
      } else if (url.indexOf("suning.com") > -1) {
        this.platform = "suning";
      } else {
        this.platform = "taobao";
      }
      const platformUrl =
        this.platformList[this.platform] || this.platformList["taobao"];
      this.Post({ url }, platformUrl, (res) => {
        if (res.states == 1) {
          this.show = true;
        }
      });
    },
    goDetail() {},
    goShare() {},
  },
};
</script>

<style lang="less" scoped>
.van-popup--center {
  width: 70%;
  background: #fff;
  min-width: 240px;
  .title {
    line-height: 48px;
    height: 40px;
    text-align: center;
    color: #ee730a;
    font-size: 14px;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/command.vue